var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index,staticClass:"badge badge-secondary badge-sm mr-2 mb-2"},[_vm._v(" "+_vm._s(tag.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }